import { render, staticRenderFns } from "./CustomizeMetalAA.vue?vue&type=template&id=abc96bfc&scoped=true"
import script from "./CustomizeMetalAA.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAA.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAA.vue?vue&type=style&index=0&id=abc96bfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc96bfc",
  null
  
)

export default component.exports